import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["role", "aria-label"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "ft-head" }
const _hoisted_4 = { class: "ft-icon" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["aria-selected", "disabled", "onClick"]
const _hoisted_7 = {
  key: 2,
  class: "ft-kinds",
  role: "tablist"
}
const _hoisted_8 = ["aria-selected", "disabled", "onClick"]
const _hoisted_9 = { class: "ft-kind-name" }
const _hoisted_10 = { class: "ft-kind-sub" }
const _hoisted_11 = {
  key: 3,
  class: "ft-error",
  role: "alert"
}
const _hoisted_12 = {
  key: 0,
  class: "ft-row"
}
const _hoisted_13 = ["value"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 1,
  class: "ft-row"
}
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 2,
  class: "ft-list ft-rockpick"
}
const _hoisted_19 = { class: "ft-label" }
const _hoisted_20 = ["value", "aria-label"]
const _hoisted_21 = { class: "ft-rockpick-name" }
const _hoisted_22 = {
  key: 0,
  class: "ft-hint"
}
const _hoisted_23 = {
  key: 1,
  class: "ft-hint"
}
const _hoisted_24 = {
  key: 0,
  class: "ft-hint"
}
const _hoisted_25 = {
  key: 3,
  class: "ft-list ft-rockpick"
}
const _hoisted_26 = { class: "ft-label" }
const _hoisted_27 = ["value", "aria-label"]
const _hoisted_28 = { class: "ft-rockpick-name" }
const _hoisted_29 = { class: "ft-hint" }
const _hoisted_30 = {
  key: 0,
  class: "ft-hint"
}
const _hoisted_31 = {
  key: 4,
  class: "ft-facts"
}
const _hoisted_32 = { class: "ft-label" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 1,
  class: "ft-stats"
}
const _hoisted_37 = {
  key: 2,
  class: "ft-hint"
}
const _hoisted_38 = {
  key: 5,
  class: "ft-facts"
}
const _hoisted_39 = { class: "ft-label" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 0,
  class: "ft-hint"
}
const _hoisted_43 = { class: "ft-describe" }
const _hoisted_44 = ["placeholder"]
const _hoisted_45 = { class: "ft-actions" }
const _hoisted_46 = { class: "ft-hint" }
const _hoisted_47 = {
  key: 5,
  class: "ft-loading",
  role: "status"
}
const _hoisted_48 = {
  key: 0,
  class: "ft-summary"
}
const _hoisted_49 = {
  key: 1,
  class: "ft-list"
}
const _hoisted_50 = { class: "ft-meta" }
const _hoisted_51 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_52 = { class: "ft-item-body" }
const _hoisted_53 = { class: "ft-grid ft-grid-metric" }
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = ["value"]
const _hoisted_57 = ["onUpdate:modelValue"]
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = ["onUpdate:modelValue"]
const _hoisted_62 = {
  key: 0,
  class: "ft-why"
}
const _hoisted_63 = {
  key: 2,
  class: "ft-list"
}
const _hoisted_64 = { class: "ft-meta" }
const _hoisted_65 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_66 = { class: "ft-item-body" }
const _hoisted_67 = { class: "ft-grid ft-grid-rock" }
const _hoisted_68 = ["onUpdate:modelValue"]
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = ["value"]
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = { class: "ft-check" }
const _hoisted_73 = ["onUpdate:modelValue"]
const _hoisted_74 = ["onUpdate:modelValue"]
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = ["value"]
const _hoisted_77 = ["onUpdate:modelValue", "min", "max"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = {
  key: 3,
  class: "ft-list"
}
const _hoisted_81 = { class: "ft-meta" }
const _hoisted_82 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_83 = { class: "ft-item-body" }
const _hoisted_84 = { class: "ft-strong" }
const _hoisted_85 = {
  key: 0,
  class: "ft-hint"
}
const _hoisted_86 = { key: 0 }
const _hoisted_87 = ["onUpdate:modelValue"]
const _hoisted_88 = ["onUpdate:modelValue"]
const _hoisted_89 = ["value"]
const _hoisted_90 = ["onUpdate:modelValue", "min", "max"]
const _hoisted_91 = ["onClick"]
const _hoisted_92 = {
  key: 2,
  class: "ft-hint"
}
const _hoisted_93 = ["onClick"]
const _hoisted_94 = {
  key: 4,
  class: "ft-list"
}
const _hoisted_95 = { class: "ft-meta" }
const _hoisted_96 = ["onUpdate:modelValue", "disabled", "aria-label"]
const _hoisted_97 = { class: "ft-item-body" }
const _hoisted_98 = { class: "ft-was" }
const _hoisted_99 = { class: "ft-was-name" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = {
  key: 1,
  class: "ft-hint"
}
const _hoisted_102 = ["onUpdate:modelValue"]
const _hoisted_103 = ["onUpdate:modelValue"]
const _hoisted_104 = {
  key: 0,
  class: "ft-why"
}
const _hoisted_105 = {
  key: 1,
  class: "ft-hint"
}
const _hoisted_106 = {
  key: 5,
  class: "ft-list"
}
const _hoisted_107 = { class: "ft-meta" }
const _hoisted_108 = ["onUpdate:modelValue", "disabled", "aria-label"]
const _hoisted_109 = { class: "ft-item-body" }
const _hoisted_110 = { class: "ft-was" }
const _hoisted_111 = { class: "ft-was-name" }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = { key: 0 }
const _hoisted_114 = {
  key: 1,
  class: "ft-hint"
}
const _hoisted_115 = { class: "ft-hint" }
const _hoisted_116 = { class: "ft-grid ft-grid-rock" }
const _hoisted_117 = ["onUpdate:modelValue"]
const _hoisted_118 = ["onUpdate:modelValue"]
const _hoisted_119 = ["value"]
const _hoisted_120 = ["onUpdate:modelValue"]
const _hoisted_121 = ["onUpdate:modelValue"]
const _hoisted_122 = {
  key: 0,
  class: "ft-why"
}
const _hoisted_123 = {
  key: 1,
  class: "ft-hint"
}
const _hoisted_124 = {
  key: 6,
  class: "ft-list"
}
const _hoisted_125 = { class: "ft-meta" }
const _hoisted_126 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_127 = { class: "ft-item-body" }
const _hoisted_128 = { class: "ft-grid ft-grid-rock" }
const _hoisted_129 = ["onUpdate:modelValue"]
const _hoisted_130 = ["onUpdate:modelValue"]
const _hoisted_131 = ["value"]
const _hoisted_132 = ["onUpdate:modelValue"]
const _hoisted_133 = { class: "ft-row ft-row-tight" }
const _hoisted_134 = ["onUpdate:modelValue"]
const _hoisted_135 = {
  key: 0,
  class: "ft-hint"
}
const _hoisted_136 = {
  key: 7,
  class: "ft-list"
}
const _hoisted_137 = { class: "ft-stats" }
const _hoisted_138 = {
  key: 0,
  class: "ft-label"
}
const _hoisted_139 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_140 = { class: "ft-item-body" }
const _hoisted_141 = { class: "ft-strong" }
const _hoisted_142 = { class: "ft-sg-detail" }
const _hoisted_143 = {
  key: 8,
  class: "ft-list"
}
const _hoisted_144 = {
  key: 0,
  class: "ft-row ft-row-tight"
}
const _hoisted_145 = { class: "ft-hint" }
const _hoisted_146 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_147 = { class: "ft-item-body" }
const _hoisted_148 = { class: "ft-strong" }
const _hoisted_149 = {
  key: 0,
  class: "ft-hint"
}
const _hoisted_150 = { class: "ft-row ft-row-tight" }
const _hoisted_151 = ["onUpdate:modelValue"]
const _hoisted_152 = ["value"]
const _hoisted_153 = ["onUpdate:modelValue", "min", "max"]
const _hoisted_154 = { class: "ft-sg-detail" }
const _hoisted_155 = ["onUpdate:modelValue"]
const _hoisted_156 = ["onUpdate:modelValue"]
const _hoisted_157 = {
  key: 1,
  class: "ft-hint"
}
const _hoisted_158 = {
  key: 9,
  class: "ft-list"
}
const _hoisted_159 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_160 = { class: "ft-item-body" }
const _hoisted_161 = { class: "ft-strong" }
const _hoisted_162 = { class: "ft-hint" }
const _hoisted_163 = { class: "ft-sg-detail" }
const _hoisted_164 = { class: "ft-row ft-row-tight" }
const _hoisted_165 = ["value"]
const _hoisted_166 = {
  key: 10,
  class: "ft-list"
}
const _hoisted_167 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_168 = { class: "ft-item-body" }
const _hoisted_169 = { class: "ft-hint" }
const _hoisted_170 = ["onUpdate:modelValue"]
const _hoisted_171 = { class: "ft-row ft-row-tight" }
const _hoisted_172 = ["onUpdate:modelValue"]
const _hoisted_173 = ["value"]
const _hoisted_174 = ["onUpdate:modelValue"]
const _hoisted_175 = {
  key: 11,
  class: "ft-list"
}
const _hoisted_176 = { class: "ft-grid ft-grid-training" }
const _hoisted_177 = { class: "ft-label" }
const _hoisted_178 = { class: "ft-chips" }
const _hoisted_179 = ["onClick"]
const _hoisted_180 = {
  key: 1,
  class: "ft-pick"
}
const _hoisted_181 = ["onClick"]
const _hoisted_182 = {
  key: 0,
  class: "ft-hint"
}
const _hoisted_183 = {
  key: 2,
  class: "ft-why"
}
const _hoisted_184 = {
  key: 12,
  class: "ft-list"
}
const _hoisted_185 = { class: "ft-meta" }
const _hoisted_186 = { class: "ft-chips" }
const _hoisted_187 = ["onClick"]
const _hoisted_188 = { class: "ft-chips" }
const _hoisted_189 = ["onClick"]
const _hoisted_190 = ["onUpdate:modelValue"]
const _hoisted_191 = { class: "ft-grid ft-grid-rating" }
const _hoisted_192 = { class: "ft-strong" }
const _hoisted_193 = ["onUpdate:modelValue"]
const _hoisted_194 = ["value"]
const _hoisted_195 = {
  key: 3,
  class: "ft-hint"
}
const _hoisted_196 = {
  key: 13,
  class: "ft-list"
}
const _hoisted_197 = { class: "ft-hint" }
const _hoisted_198 = { class: "ft-chips" }
const _hoisted_199 = ["value"]
const _hoisted_200 = {
  key: 14,
  class: "ft-list"
}
const _hoisted_201 = { class: "ft-grid ft-grid-event" }
const _hoisted_202 = ["value"]
const _hoisted_203 = ["value"]
const _hoisted_204 = { class: "ft-check" }
const _hoisted_205 = { class: "ft-chips" }
const _hoisted_206 = ["value"]
const _hoisted_207 = {
  key: 15,
  class: "ft-warn"
}
const _hoisted_208 = {
  key: 16,
  class: "ft-error",
  role: "alert"
}
const _hoisted_209 = { class: "ft-revise" }
const _hoisted_210 = ["placeholder"]
const _hoisted_211 = { class: "ft-actions" }
const _hoisted_212 = ["disabled"]
const _hoisted_213 = ["disabled"]
const _hoisted_214 = {
  key: 7,
  class: "ft-done"
}
const _hoisted_215 = { class: "ft-done-msg" }
const _hoisted_216 = {
  key: 0,
  class: "ft-error"
}
const _hoisted_217 = { class: "ft-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_ai_dictation = _resolveComponent("ai-dictation")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.actions.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.modal ? (_ctx.docked ? 'ft-dock-wrap' : 'error-msg-wrap') : 'ft-host'),
        style: _normalizeStyle(_ctx.docked ? { top: _ctx.dockTop + 'px' } : undefined)
      }, [
        _createElementVNode("section", {
          class: _normalizeClass(["ft", { 'form-wrapper slide-up ft-modal': _ctx.modal && !_ctx.docked, 'ft-docked': _ctx.docked }]),
          role: _ctx.modal ? (_ctx.docked ? 'complementary' : 'dialog') : null,
          "aria-label": _ctx.modal ? 'The Forge' : null
        }, [
          (_ctx.modal)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "ft-close",
                title: "Close",
                disabled: _ctx.busy,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, "×", 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_svg_icon, { icon: "twousers" })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.modal ? 'The Forge' : _ctx.single ? _ctx.familyLabel : 'Forge for your team'), 1),
              _cache[36] || (_cache[36] = _createElementVNode("p", null, "Describe it, check the draft, then add it. Nothing is saved or sent until you say so.", -1))
            ])
          ]),
          (_ctx.single && _ctx.variants.length > 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "ft-variants",
                role: "tablist",
                "aria-label": _ctx.familyLabel
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variants, (v) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: v.key,
                    type: "button",
                    role: "tab",
                    "aria-selected": _ctx.kind == v.key,
                    class: _normalizeClass(["ft-variant", { 'ft-variant-on': _ctx.kind == v.key }]),
                    disabled: _ctx.busy,
                    onClick: ($event: any) => (_ctx.kind != v.key && _ctx.pick(v.key))
                  }, _toDisplayString(v.label), 11, _hoisted_6))
                }), 128))
              ], 8, _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.actions.length > 1 && !_ctx.single)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (a) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: a.key,
                    type: "button",
                    role: "tab",
                    "aria-selected": _ctx.kind == a.key,
                    class: _normalizeClass(["ft-kind", { 'ft-kind-on': _ctx.kind == a.key }]),
                    disabled: _ctx.busy,
                    onClick: ($event: any) => (_ctx.pick(a.key))
                  }, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(a.label), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(a.sub), 1)
                  ], 10, _hoisted_8))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.loadError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.loadError), 1))
            : _createCommentVNode("", true),
          (_ctx.kind && _ctx.phase == 'input')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (_ctx.kind == 'scorecard' || _ctx.usesRocks)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("label", null, [
                        _cache[37] || (_cache[37] = _createTextVNode("Team ", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.team) = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamOptions, (t) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: t,
                              value: t
                            }, _toDisplayString(_ctx.teamLabel(t)), 9, _hoisted_13))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.team]
                        ])
                      ]),
                      (_ctx.usesRocks)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_14, [
                            _cache[38] || (_cache[38] = _createTextVNode("Quarter ", -1)),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.quarter) = $event))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quarterOptions, (q) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: q,
                                  value: q
                                }, _toDisplayString(_ctx.quarterLabel(q)) + _toDisplayString(q == _ctx.quarterOptions[0] ? ' · now' : ' · next'), 9, _hoisted_15))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.quarter]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'skills')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("label", null, [
                        _cache[40] || (_cache[40] = _createTextVNode("Matrix ", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.matrixID) = $event))
                        }, [
                          _cache[39] || (_cache[39] = _createElementVNode("option", { value: null }, "Let the Forge pick, or start a new one", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matrices, (m) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: m.ID,
                              value: m.ID
                            }, _toDisplayString(m.Name), 9, _hoisted_17))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.matrixID]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.picksRocks && _ctx.ready)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, "Rocks to " + _toDisplayString(_ctx.kind == 'improve' ? 'improve' : 'plan') + " · " + _toDisplayString(_ctx.pickedRocks.length) + " of " + _toDisplayString(_ctx.editableRocks.length), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editableRocks, (r) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: r.ID,
                          class: "ft-item ft-item-tight"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: r.ID,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pickedRocks) = $event)),
                            "aria-label": (_ctx.kind == 'improve' ? 'Improve ' : 'Plan ') + r.Name
                          }, null, 8, _hoisted_20), [
                            [_vModelCheckbox, _ctx.pickedRocks]
                          ]),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(r.Name), 1),
                          (_ctx.kind == 'improve')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(r.DoneStatement ? '' : 'no done statement yet'), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(r.Milestones.length ? r.Milestones.length + ' milestone' + (r.Milestones.length == 1 ? '' : 's') : 'no milestones yet'), 1))
                        ]))
                      }), 128)),
                      (!_ctx.editableRocks.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, "No open Rocks you can edit on " + _toDisplayString(_ctx.teamLabel(_ctx.team)) + " for " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + ". Add some with Rocks first.", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'improvemetrics' && _ctx.ready)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, "Metrics to improve · " + _toDisplayString(_ctx.pickedMetrics.length) + " of " + _toDisplayString(_ctx.teamMetrics.length), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMetrics, (m) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: m.ID,
                          class: "ft-item ft-item-tight"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: m.ID,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pickedMetrics) = $event)),
                            "aria-label": 'Improve ' + m.Name
                          }, null, 8, _hoisted_27), [
                            [_vModelCheckbox, _ctx.pickedMetrics]
                          ]),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(m.Name), 1),
                          _createElementVNode("span", _hoisted_29, _toDisplayString([ m.Definition ? '' : 'no definition', m.OwnerEmployeeID ? '' : 'no owner' ].filter(Boolean).join(' · ')), 1)
                        ]))
                      }), 128)),
                      (!_ctx.teamMetrics.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.teamLabel(_ctx.team)) + " has no metrics yet. Add some with Scorecard first.", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.forMeeting && _ctx.ready)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.kind == 'prepl10' ? 'The Forge will look at' : 'From ' + _ctx.meeting.name), 1),
                      (_ctx.kind == 'prepl10')
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_33, [
                            (_ctx.meeting.team)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.facts.offTrackRocks.length), 1),
                                  _createTextVNode(" Rock" + _toDisplayString(_ctx.facts.offTrackRocks.length == 1 ? '' : 's') + " off track or behind on milestones", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.meeting.team)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.facts.scorecard.length), 1),
                                  _createTextVNode(" number" + _toDisplayString(_ctx.facts.scorecard.length == 1 ? '' : 's') + " off goal 2+ weeks or not entered last week", 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("li", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.facts.overdueTodos.length), 1),
                              _createTextVNode(" overdue to-do" + _toDisplayString(_ctx.facts.overdueTodos.length == 1 ? '' : 's'), 1)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.facts.existingIssues.length), 1),
                              _createTextVNode(" Issue" + _toDisplayString(_ctx.facts.existingIssues.length == 1 ? '' : 's') + " already open (it won't repeat them)", 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statTiles, (t) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: t.label,
                                class: "ft-stat"
                              }, [
                                _createElementVNode("strong", null, _toDisplayString(t.value), 1),
                                _createElementVNode("span", null, _toDisplayString(t.label), 1)
                              ]))
                            }), 128))
                          ])),
                      (_ctx.kind == 'prepl10' && !_ctx.meeting.team)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, "This is a personal meeting, so only its to-dos are checked. Team meetings also bring in the team's Rocks and scorecard."))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.forBoard && _ctx.ready)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, "From " + _toDisplayString(_ctx.board.name), 1),
                      _createElementVNode("ul", null, [
                        (_ctx.kind == 'sortinbox')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.inbox.length), 1),
                              _createTextVNode(" item" + _toDisplayString(_ctx.inbox.length == 1 ? '' : 's') + " in your Inbox", 1)
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("li", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.boardFacts.open.length), 1),
                                _createTextVNode(" open card" + _toDisplayString(_ctx.boardFacts.open.length == 1 ? '' : 's'), 1),
                                (_ctx.kind == 'tidyboard')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _cache[41] || (_cache[41] = _createTextVNode(" · ", -1)),
                                      _createElementVNode("b", null, _toDisplayString(_ctx.boardFacts.overdue), 1),
                                      _cache[42] || (_cache[42] = _createTextVNode(" overdue · ", -1)),
                                      _createElementVNode("b", null, _toDisplayString(_ctx.boardFacts.stale), 1),
                                      _cache[43] || (_cache[43] = _createTextVNode(" unchanged for 3+ weeks · ", -1)),
                                      _createElementVNode("b", null, _toDisplayString(_ctx.boardFacts.undated + _ctx.boardFacts.steps.length), 1),
                                      _cache[44] || (_cache[44] = _createTextVNode(" with no due date", -1))
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[45] || (_cache[45] = _createTextVNode(" · ", -1)),
                                      _createElementVNode("b", null, _toDisplayString(_ctx.boardFacts.dueThisWeek), 1),
                                      _cache[46] || (_cache[46] = _createTextVNode(" due by Sunday", -1))
                                    ], 64))
                              ]),
                              (_ctx.kind == 'planweek')
                                ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                                    _createElementVNode("b", null, _toDisplayString(_ctx.myRocks.length), 1),
                                    _createTextVNode(" Rock" + _toDisplayString(_ctx.myRocks.length == 1 ? '' : 's') + " you own this quarter", 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                      ]),
                      (_ctx.kind == 'sortinbox' && !_ctx.inbox.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Your Inbox is empty. Text a note to your Inbox number, or drag a card into the Inbox panel."))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_43, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.description) = $event)),
                    rows: "4",
                    placeholder: _ctx.current.placeholder,
                    maxlength: "8000"
                  }, null, 8, _hoisted_44), [
                    [_vModelText, _ctx.description]
                  ]),
                  _createVNode(_component_ai_dictation, {
                    class: "ft-mic",
                    onText: _cache[7] || (_cache[7] = t => _ctx.description = (_ctx.description ? _ctx.description.trimEnd() + ' ' : '') + t)
                  })
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.current.hint), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["ai-btn", { 'disable-button': !_ctx.canDraft }]),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.draftIt()))
                  }, _toDisplayString(_ctx.ready ? 'Draft it' : 'Loading…'), 3)
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.phase == 'loading')
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "ft-orb" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.loadingText), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.phase == 'review' && _ctx.draft)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                (_ctx.draft.summary)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_ctx.draft.summary), 1))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'scorecard')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _cache[48] || (_cache[48] = _createTextVNode("For ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.teamLabel(_ctx.team)), 1),
                        _cache[49] || (_cache[49] = _createTextVNode(" · goals start this week", -1))
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.metrics, (m, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: _normalizeClass(["ft-item", { 'ft-off': !m.keep }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((m.keep) = $event),
                            "aria-label": 'Add ' + m.name
                          }, null, 8, _hoisted_51), [
                            [_vModelCheckbox, m.keep]
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((m.name) = $event),
                                maxlength: "80",
                                "aria-label": "Metric name",
                                class: "ft-strong"
                              }, null, 8, _hoisted_54), [
                                [_vModelText, m.name]
                              ]),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((m.ownerEmployeeID) = $event),
                                "aria-label": "Owner"
                              }, [
                                _cache[50] || (_cache[50] = _createElementVNode("option", { value: null }, "No owner yet", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: e.ID,
                                    value: e.ID
                                  }, _toDisplayString(e.Name), 9, _hoisted_56))
                                }), 128))
                              ], 8, _hoisted_55), [
                                [_vModelSelect, m.ownerEmployeeID]
                              ]),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((m.cmp) = $event),
                                "aria-label": "Goal type"
                              }, [...(_cache[51] || (_cache[51] = [
                                _createElementVNode("option", { value: "gte" }, "At least", -1),
                                _createElementVNode("option", { value: "lte" }, "At most", -1),
                                _createElementVNode("option", { value: "eq" }, "Exactly", -1),
                                _createElementVNode("option", { value: "range" }, "Between", -1)
                              ]))], 8, _hoisted_57), [
                                [_vModelSelect, m.cmp]
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": ($event: any) => ((m.goal) = $event),
                                step: "any",
                                "aria-label": "Goal"
                              }, null, 8, _hoisted_58), [
                                [
                                  _vModelText,
                                  m.goal,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              (m.cmp == 'range')
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((m.goalMax) = $event),
                                    step: "any",
                                    "aria-label": "Goal maximum",
                                    placeholder: "and"
                                  }, null, 8, _hoisted_59)), [
                                    [
                                      _vModelText,
                                      m.goalMax,
                                      void 0,
                                      { number: true }
                                    ]
                                  ])
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((m.unit) = $event),
                                maxlength: "12",
                                "aria-label": "Unit",
                                placeholder: "unit",
                                class: "ft-unit"
                              }, null, 8, _hoisted_60), [
                                [_vModelText, m.unit]
                              ])
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((m.definition) = $event),
                              "aria-label": "Definition",
                              placeholder: "What counts, and where the number comes from"
                            }, null, 8, _hoisted_61), [
                              [_vModelText, m.definition]
                            ]),
                            (m.why)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(m.why), 1))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'rocks')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _cache[52] || (_cache[52] = _createTextVNode("For ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.teamLabel(_ctx.team)), 1),
                        _createTextVNode(" · " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + " (" + _toDisplayString(_ctx.shortDate(_ctx.bounds.start)) + " – " + _toDisplayString(_ctx.shortDate(_ctx.bounds.end)) + ")", 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.rocks, (r, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: _normalizeClass(["ft-item", { 'ft-off': !r.keep }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((r.keep) = $event),
                            "aria-label": 'Add ' + r.name
                          }, null, 8, _hoisted_65), [
                            [_vModelCheckbox, r.keep]
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((r.name) = $event),
                                maxlength: "200",
                                "aria-label": "Rock",
                                class: "ft-strong"
                              }, null, 8, _hoisted_68), [
                                [_vModelText, r.name]
                              ]),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((r.ownerEmployeeID) = $event),
                                "aria-label": "Owner"
                              }, [
                                _cache[53] || (_cache[53] = _createElementVNode("option", { value: null }, "No owner yet", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: e.ID,
                                    value: e.ID
                                  }, _toDisplayString(e.Name), 9, _hoisted_70))
                                }), 128))
                              ], 8, _hoisted_69), [
                                [_vModelSelect, r.ownerEmployeeID]
                              ])
                            ]),
                            _cache[56] || (_cache[56] = _createElementVNode("label", { class: "ft-label" }, "Done looks like", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((r.doneStatement) = $event),
                              rows: "2",
                              maxlength: "1000",
                              class: "ft-fit"
                            }, null, 8, _hoisted_71), [
                              [_vModelText, r.doneStatement]
                            ]),
                            _createElementVNode("label", _hoisted_72, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((r.teamRock) = $event)
                              }, null, 8, _hoisted_73), [
                                [_vModelCheckbox, r.teamRock]
                              ]),
                              _cache[54] || (_cache[54] = _createTextVNode(" Team Rock (the whole team owns it)", -1))
                            ]),
                            _cache[57] || (_cache[57] = _createElementVNode("label", { class: "ft-label" }, "Milestones", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.milestones, (ms, j) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: j,
                                class: "ft-grid ft-grid-ms"
                              }, [
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": ($event: any) => ((ms.text) = $event),
                                  rows: "1",
                                  "aria-label": "Milestone",
                                  class: "ft-ms-text"
                                }, null, 8, _hoisted_74), [
                                  [_vModelText, ms.text]
                                ]),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": ($event: any) => ((ms.ownerEmployeeID) = $event),
                                  "aria-label": "Milestone owner"
                                }, [
                                  _cache[55] || (_cache[55] = _createElementVNode("option", { value: null }, "—", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: e.ID,
                                      value: e.ID
                                    }, _toDisplayString(e.Name), 9, _hoisted_76))
                                  }), 128))
                                ], 8, _hoisted_75), [
                                  [_vModelSelect, ms.ownerEmployeeID]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "date",
                                  "onUpdate:modelValue": ($event: any) => ((ms.dueDate) = $event),
                                  min: _ctx.bounds.start,
                                  max: _ctx.bounds.end,
                                  "aria-label": "Due"
                                }, null, 8, _hoisted_77), [
                                  [_vModelText, ms.dueDate]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ft-x",
                                  title: "Remove milestone",
                                  onClick: ($event: any) => (r.milestones.splice(j, 1))
                                }, "×", 8, _hoisted_78)
                              ]))
                            }), 128)),
                            _createElementVNode("a", {
                              class: "ft-add",
                              onClick: _withModifiers(($event: any) => (r.milestones.push({ text: '', ownerEmployeeID: r.ownerEmployeeID, dueDate: _ctx.bounds.end })), ["prevent"])
                            }, "+ Add a milestone", 8, _hoisted_79)
                          ])
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'milestones')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _cache[58] || (_cache[58] = _createTextVNode("For ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.teamLabel(_ctx.team)), 1),
                        _createTextVNode(" · " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + " · due by " + _toDisplayString(_ctx.shortDate(_ctx.bounds.end)), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.rocks, (r) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: r.rockID,
                          class: _normalizeClass(["ft-item", { 'ft-off': !r.keep }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((r.keep) = $event),
                            "aria-label": 'Add milestones to ' + r.name
                          }, null, 8, _hoisted_82), [
                            [_vModelCheckbox, r.keep]
                          ]),
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, _toDisplayString(r.name), 1),
                            (r.doneStatement)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_85, "Done looks like: " + _toDisplayString(r.doneStatement), 1))
                              : _createCommentVNode("", true),
                            (r.existing.length)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _cache[59] || (_cache[59] = _createElementVNode("label", { class: "ft-label" }, "Already on it", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.existing, (ms, j) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'e' + j,
                                      class: _normalizeClass(["ft-existing", { 'ft-existing-done': ms.Done }])
                                    }, [
                                      _createTextVNode(_toDisplayString(ms.Done ? '✓ ' : '') + _toDisplayString(ms.Text), 1),
                                      (ms.DueDate)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_86, " · " + _toDisplayString(_ctx.shortDate(ms.DueDate)), 1))
                                        : _createCommentVNode("", true)
                                    ], 2))
                                  }), 128))
                                ], 64))
                              : _createCommentVNode("", true),
                            _cache[61] || (_cache[61] = _createElementVNode("label", { class: "ft-label" }, "New milestones", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.milestones, (ms, j) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: j,
                                class: "ft-grid ft-grid-ms"
                              }, [
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": ($event: any) => ((ms.text) = $event),
                                  rows: "1",
                                  "aria-label": "Milestone",
                                  class: "ft-ms-text"
                                }, null, 8, _hoisted_87), [
                                  [_vModelText, ms.text]
                                ]),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": ($event: any) => ((ms.ownerEmployeeID) = $event),
                                  "aria-label": "Milestone owner"
                                }, [
                                  _cache[60] || (_cache[60] = _createElementVNode("option", { value: null }, "—", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: e.ID,
                                      value: e.ID
                                    }, _toDisplayString(e.Name), 9, _hoisted_89))
                                  }), 128))
                                ], 8, _hoisted_88), [
                                  [_vModelSelect, ms.ownerEmployeeID]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "date",
                                  "onUpdate:modelValue": ($event: any) => ((ms.dueDate) = $event),
                                  min: _ctx.earliest,
                                  max: _ctx.bounds.end,
                                  "aria-label": "Due"
                                }, null, 8, _hoisted_90), [
                                  [_vModelText, ms.dueDate]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ft-x",
                                  title: "Remove milestone",
                                  onClick: ($event: any) => (r.milestones.splice(j, 1))
                                }, "×", 8, _hoisted_91)
                              ]))
                            }), 128)),
                            (!r.milestones.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_92, "Nothing new suggested; it already looks planned."))
                              : _createCommentVNode("", true),
                            _createElementVNode("a", {
                              class: "ft-add",
                              onClick: _withModifiers(($event: any) => (r.milestones.push({ text: '', ownerEmployeeID: r.ownerEmployeeID, dueDate: _ctx.bounds.end })), ["prevent"])
                            }, "+ Add a milestone", 8, _hoisted_93)
                          ])
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'improve')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                      _createElementVNode("div", _hoisted_95, [
                        _cache[62] || (_cache[62] = _createTextVNode("For ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.teamLabel(_ctx.team)), 1),
                        _createTextVNode(" · " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + " · owners, status and milestones stay as they are", 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.rocks, (r) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: r.rockID,
                          class: _normalizeClass(["ft-item", { 'ft-off': !r.keep || !_ctx.rockChanged(r) }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((r.keep) = $event),
                            disabled: !_ctx.rockChanged(r),
                            "aria-label": 'Update ' + r.oldName
                          }, null, 8, _hoisted_96), [
                            [_vModelCheckbox, r.keep]
                          ]),
                          _createElementVNode("div", _hoisted_97, [
                            _cache[63] || (_cache[63] = _createElementVNode("label", { class: "ft-label" }, "Now", -1)),
                            _createElementVNode("div", _hoisted_98, [
                              _createElementVNode("div", _hoisted_99, _toDisplayString(r.oldName), 1),
                              (r.oldDone)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_100, "Done: " + _toDisplayString(r.oldDone), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_101, "No done statement yet"))
                            ]),
                            _cache[64] || (_cache[64] = _createElementVNode("label", { class: "ft-label" }, "Suggested", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((r.name) = $event),
                              maxlength: "200",
                              "aria-label": "Rock",
                              class: "ft-strong"
                            }, null, 8, _hoisted_102), [
                              [_vModelText, r.name]
                            ]),
                            _cache[65] || (_cache[65] = _createElementVNode("label", { class: "ft-label" }, "Done looks like", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((r.doneStatement) = $event),
                              rows: "2",
                              maxlength: "1000",
                              class: "ft-fit",
                              "aria-label": "Done looks like"
                            }, null, 8, _hoisted_103), [
                              [_vModelText, r.doneStatement]
                            ]),
                            (r.why)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_104, _toDisplayString(r.why), 1))
                              : _createCommentVNode("", true),
                            (!_ctx.rockChanged(r))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_105, "No change: it already reads clearly."))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'improvemetrics')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _cache[66] || (_cache[66] = _createTextVNode("For ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.teamLabel(_ctx.team)), 1),
                        _cache[67] || (_cache[67] = _createTextVNode(" · goals and past numbers stay as they are", -1))
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.metrics, (m) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: m.metricID,
                          class: _normalizeClass(["ft-item", { 'ft-off': !m.keep || !_ctx.metricChanged(m) }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((m.keep) = $event),
                            disabled: !_ctx.metricChanged(m),
                            "aria-label": 'Update ' + m.old.name
                          }, null, 8, _hoisted_108), [
                            [_vModelCheckbox, m.keep]
                          ]),
                          _createElementVNode("div", _hoisted_109, [
                            _cache[69] || (_cache[69] = _createElementVNode("label", { class: "ft-label" }, "Now", -1)),
                            _createElementVNode("div", _hoisted_110, [
                              _createElementVNode("div", _hoisted_111, [
                                _createTextVNode(_toDisplayString(m.old.name), 1),
                                (m.old.unit)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_112, " (" + _toDisplayString(m.old.unit) + ")", 1))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" · goal " + _toDisplayString(m.goalText), 1)
                              ]),
                              (m.old.definition)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_113, _toDisplayString(m.old.definition), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_114, "No definition yet")),
                              _createElementVNode("div", _hoisted_115, _toDisplayString(m.old.ownerEmployeeID ? 'Owner: ' + _ctx.personName(m.old.ownerEmployeeID) : 'No owner yet'), 1)
                            ]),
                            _cache[70] || (_cache[70] = _createElementVNode("label", { class: "ft-label" }, "Suggested", -1)),
                            _createElementVNode("div", _hoisted_116, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((m.name) = $event),
                                maxlength: "80",
                                "aria-label": "Metric name",
                                class: "ft-strong"
                              }, null, 8, _hoisted_117), [
                                [_vModelText, m.name]
                              ]),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((m.ownerEmployeeID) = $event),
                                "aria-label": "Owner"
                              }, [
                                _cache[68] || (_cache[68] = _createElementVNode("option", { value: null }, "No owner yet", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: e.ID,
                                    value: e.ID
                                  }, _toDisplayString(e.Name), 9, _hoisted_119))
                                }), 128))
                              ], 8, _hoisted_118), [
                                [_vModelSelect, m.ownerEmployeeID]
                              ])
                            ]),
                            _cache[71] || (_cache[71] = _createElementVNode("label", { class: "ft-label" }, "Definition", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((m.definition) = $event),
                              rows: "2",
                              maxlength: "1000",
                              class: "ft-fit",
                              "aria-label": "Definition"
                            }, null, 8, _hoisted_120), [
                              [_vModelText, m.definition]
                            ]),
                            _cache[72] || (_cache[72] = _createElementVNode("label", { class: "ft-label" }, "Unit", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((m.unit) = $event),
                              maxlength: "12",
                              "aria-label": "Unit",
                              placeholder: "none (a count)",
                              class: "ft-unit"
                            }, null, 8, _hoisted_121), [
                              [_vModelText, m.unit]
                            ]),
                            (m.why)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_122, _toDisplayString(m.why), 1))
                              : _createCommentVNode("", true),
                            (!_ctx.metricChanged(m))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_123, "No change: it already reads clearly."))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'prepl10')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                      _createElementVNode("div", _hoisted_125, [
                        _cache[73] || (_cache[73] = _createTextVNode("Added to ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.facts.issuesColumn), 1),
                        _createTextVNode(" on " + _toDisplayString(_ctx.meeting.name), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.issues, (it, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: _normalizeClass(["ft-item", { 'ft-off': !it.keep }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((it.keep) = $event),
                            "aria-label": 'Add ' + it.name
                          }, null, 8, _hoisted_126), [
                            [_vModelCheckbox, it.keep]
                          ]),
                          _createElementVNode("div", _hoisted_127, [
                            _createElementVNode("div", _hoisted_128, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((it.name) = $event),
                                maxlength: "200",
                                "aria-label": "Issue",
                                class: "ft-strong"
                              }, null, 8, _hoisted_129), [
                                [_vModelText, it.name]
                              ]),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((it.assigneeEmployeeID) = $event),
                                "aria-label": "Owner"
                              }, [
                                _cache[74] || (_cache[74] = _createElementVNode("option", { value: null }, "No owner", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: e.ID,
                                    value: e.ID
                                  }, _toDisplayString(e.Name), 9, _hoisted_131))
                                }), 128))
                              ], 8, _hoisted_130), [
                                [_vModelSelect, it.assigneeEmployeeID]
                              ])
                            ]),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((it.description) = $event),
                              rows: "2",
                              maxlength: "2000",
                              class: "ft-fit",
                              "aria-label": "Details"
                            }, null, 8, _hoisted_132), [
                              [_vModelText, it.description]
                            ]),
                            _createElementVNode("div", _hoisted_133, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["ft-tag", 'ft-tag-' + it.source])
                              }, _toDisplayString(_ctx.sourceLabel(it.source)), 3),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((it.priority) = $event),
                                "aria-label": "Priority",
                                class: "ft-pri"
                              }, [...(_cache[75] || (_cache[75] = [
                                _createElementVNode("option", { value: "high" }, "High", -1),
                                _createElementVNode("option", { value: "med" }, "Medium", -1),
                                _createElementVNode("option", { value: "low" }, "Low", -1)
                              ]))], 8, _hoisted_134), [
                                [_vModelSelect, it.priority]
                              ])
                            ])
                          ])
                        ], 2))
                      }), 128)),
                      (!_ctx.draft.issues.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_135, "Nothing new to discuss: no new Issues suggested."))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'meetingcheckup')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                      _createElementVNode("div", _hoisted_137, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statTiles, (t) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: t.label,
                            class: "ft-stat"
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(t.value), 1),
                            _createElementVNode("span", null, _toDisplayString(t.label), 1)
                          ]))
                        }), 128))
                      ]),
                      (_ctx.draft.suggestions.length)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_138, "Suggestions · tick any to add to " + _toDisplayString(_ctx.facts.issuesColumn), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.suggestions, (sg, i) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: i,
                          class: "ft-item ft-item-tight"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((sg.keep) = $event),
                            "aria-label": 'Add ' + sg.title + ' to Issues'
                          }, null, 8, _hoisted_139), [
                            [_vModelCheckbox, sg.keep]
                          ]),
                          _createElementVNode("span", _hoisted_140, [
                            _createElementVNode("span", _hoisted_141, _toDisplayString(sg.title), 1),
                            _createElementVNode("span", _hoisted_142, _toDisplayString(sg.detail), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'tidyboard')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                      (_ctx.dueActions.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                            _createElementVNode("span", _hoisted_145, _toDisplayString(_ctx.dueActions.length) + " due date" + _toDisplayString(_ctx.dueActions.length == 1 ? '' : 's') + " suggested ·", 1),
                            _createElementVNode("a", {
                              class: "ft-add",
                              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => {_ctx.dueActions.forEach(a => { a.keep = true; })}, ["prevent"]))
                            }, "Tick all dates"),
                            _createElementVNode("a", {
                              class: "ft-add",
                              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => {_ctx.dueActions.forEach(a => { a.keep = false; })}, ["prevent"]))
                            }, "Untick all dates")
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.actions, (a, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: _normalizeClass(["ft-item", { 'ft-off': !a.keep }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((a.keep) = $event),
                            "aria-label": _ctx.actionLabel(a) + ': ' + (a.stepName || a.cardName)
                          }, null, 8, _hoisted_146), [
                            [_vModelCheckbox, a.keep]
                          ]),
                          _createElementVNode("div", _hoisted_147, [
                            _createElementVNode("div", _hoisted_148, _toDisplayString(a.stepName || a.cardName), 1),
                            (a.stepName)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                  _createTextVNode("Checklist step on " + _toDisplayString(a.cardName), 1),
                                  (a.card && a.card.Date)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" · card due " + _toDisplayString(_ctx.shortDate(a.card.Date)), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_150, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["ft-tag", 'ft-tag-' + (a.action == 'rock' ? 'rock' : a.action == 'done' ? 'todo' : a.action == 'due' ? 'other' : 'scorecard')])
                              }, _toDisplayString(_ctx.actionLabel(a)), 3),
                              (a.action == 'move')
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 0,
                                    "onUpdate:modelValue": ($event: any) => ((a.toColumn) = $event),
                                    "aria-label": "Move to",
                                    class: "ft-pri"
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.board.columns, (c) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: c,
                                        value: c
                                      }, _toDisplayString(c), 9, _hoisted_152))
                                    }), 128))
                                  ], 8, _hoisted_151)), [
                                    [_vModelSelect, a.toColumn]
                                  ])
                                : _createCommentVNode("", true),
                              (a.action == 'due')
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    type: "date",
                                    "onUpdate:modelValue": ($event: any) => ((a.dueDate) = $event),
                                    min: _ctx.todayDate,
                                    max: a.maxDate || null,
                                    "aria-label": "Due date",
                                    class: "ft-pri"
                                  }, null, 8, _hoisted_153)), [
                                    [_vModelText, a.dueDate]
                                  ])
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_154, _toDisplayString(a.reason), 1),
                            (a.action == 'rock')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _cache[76] || (_cache[76] = _createElementVNode("label", { class: "ft-label" }, "Rock", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((a.rockName) = $event),
                                    maxlength: "200",
                                    "aria-label": "Rock",
                                    class: "ft-strong"
                                  }, null, 8, _hoisted_155), [
                                    [_vModelText, a.rockName]
                                  ]),
                                  _cache[77] || (_cache[77] = _createElementVNode("label", { class: "ft-label" }, "Done looks like", -1)),
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": ($event: any) => ((a.doneStatement) = $event),
                                    rows: "2",
                                    maxlength: "1000",
                                    class: "ft-fit",
                                    "aria-label": "Done looks like"
                                  }, null, 8, _hoisted_156), [
                                    [_vModelText, a.doneStatement]
                                  ])
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      }), 128)),
                      (!_ctx.draft.actions.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_157, "The board already looks tidy and every card has a date: nothing to change."))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'planweek')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.picks, (p, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: p.cardID,
                          class: _normalizeClass(["ft-item", { 'ft-off': !p.keep }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((p.keep) = $event),
                            "aria-label": 'Focus on ' + p.name
                          }, null, 8, _hoisted_159), [
                            [_vModelCheckbox, p.keep]
                          ]),
                          _createElementVNode("div", _hoisted_160, [
                            _createElementVNode("div", _hoisted_161, _toDisplayString(i + 1) + ". " + _toDisplayString(p.name), 1),
                            _createElementVNode("div", _hoisted_162, [
                              _createTextVNode(_toDisplayString(p.column), 1),
                              (p.due)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" · due " + _toDisplayString(_ctx.shortDate(p.due)), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_163, _toDisplayString(p.why), 1)
                          ])
                        ], 2))
                      }), 128)),
                      _createElementVNode("div", _hoisted_164, [
                        _createElementVNode("label", null, [
                          _cache[79] || (_cache[79] = _createTextVNode("Move the ticked cards to ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.draft.toColumn) = $event)),
                            "aria-label": "Move to column"
                          }, [
                            _cache[78] || (_cache[78] = _createElementVNode("option", { value: "" }, "Don't move them", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.board.columns, (c) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: c,
                                value: c
                              }, _toDisplayString(c), 9, _hoisted_165))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.draft.toColumn]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'sortinbox')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.items, (it) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: it.inboxID,
                          class: _normalizeClass(["ft-item", { 'ft-off': !it.keep }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((it.keep) = $event),
                            "aria-label": 'Add ' + it.name
                          }, null, 8, _hoisted_167), [
                            [_vModelCheckbox, it.keep]
                          ]),
                          _createElementVNode("div", _hoisted_168, [
                            _createElementVNode("div", _hoisted_169, "From your Inbox: " + _toDisplayString(it.original), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((it.name) = $event),
                              maxlength: "255",
                              "aria-label": "Card title",
                              class: "ft-strong"
                            }, null, 8, _hoisted_170), [
                              [_vModelText, it.name]
                            ]),
                            _createElementVNode("div", _hoisted_171, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((it.column) = $event),
                                "aria-label": "Column",
                                class: "ft-pri"
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.board.columns, (c) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: c,
                                    value: c
                                  }, _toDisplayString(c), 9, _hoisted_173))
                                }), 128))
                              ], 8, _hoisted_172), [
                                [_vModelSelect, it.column]
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                type: "date",
                                "onUpdate:modelValue": ($event: any) => ((it.dueDate) = $event),
                                "aria-label": "Due date",
                                class: "ft-pri"
                              }, null, 8, _hoisted_174), [
                                [_vModelText, it.dueDate]
                              ])
                            ])
                          ])
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'training')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                      _createElementVNode("div", _hoisted_176, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.draft.name) = $event)),
                          maxlength: "200",
                          "aria-label": "Session name",
                          class: "ft-strong"
                        }, null, 512), [
                          [_vModelText, _ctx.draft.name]
                        ]),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.draft.type) = $event)),
                          "aria-label": "Session type"
                        }, [...(_cache[80] || (_cache[80] = [
                          _createElementVNode("option", { value: "Classroom" }, "Classroom", -1),
                          _createElementVNode("option", { value: "On-site" }, "On-site", -1)
                        ]))], 512), [
                          [_vModelSelect, _ctx.draft.type]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.draft.date) = $event)),
                          "aria-label": "Date"
                        }, null, 512), [
                          [_vModelText, _ctx.draft.date]
                        ])
                      ]),
                      (_ctx.draft.type == 'On-site')
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "text",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.draft.station) = $event)),
                            placeholder: "Station, e.g. Expander Line 2",
                            "aria-label": "Station"
                          }, null, 512)), [
                            [_vModelText, _ctx.draft.station]
                          ])
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.draft.reviewingText) = $event)),
                        rows: "2",
                        placeholder: "What to focus on (optional)",
                        class: "ft-fit"
                      }, null, 512), [
                        [_vModelText, _ctx.draft.reviewingText]
                      ]),
                      _createElementVNode("label", _hoisted_177, _toDisplayString(_ctx.draft.type == 'On-site' ? 'Related processes' : 'Processes to review') + " · " + _toDisplayString(_ctx.draft.processSlugs.length), 1),
                      _createElementVNode("div", _hoisted_178, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.processSlugs, (slug) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: slug,
                            class: "ft-chip"
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.nodeName(slug)), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ft-x",
                              title: "Remove",
                              onClick: ($event: any) => (_ctx.draft.processSlugs = _ctx.draft.processSlugs.filter(s => s != slug))
                            }, "×", 8, _hoisted_179)
                          ]))
                        }), 128))
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.processQ) = $event)),
                        placeholder: "Add another process…",
                        "aria-label": "Search processes"
                      }, null, 512), [
                        [_vModelText, _ctx.processQ]
                      ]),
                      (_ctx.processQ.trim().length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processMatches, (n) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: n.Slug,
                                class: "ft-pick-row",
                                onClick: ($event: any) => {_ctx.draft.processSlugs.push(n.Slug); _ctx.processQ = ''}
                              }, _toDisplayString(n.Name), 9, _hoisted_181))
                            }), 128)),
                            (!_ctx.processMatches.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_182, "No match"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.draft.why)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_183, _toDisplayString(_ctx.draft.why), 1))
                        : _createCommentVNode("", true),
                      _cache[81] || (_cache[81] = _createElementVNode("div", { class: "ft-hint" }, "Attendees are picked when the session starts, as usual.", -1))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'skills')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                      _createElementVNode("div", _hoisted_185, [
                        (_ctx.skillsTarget)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[82] || (_cache[82] = _createTextVNode("Updating ", -1)),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.skillsTarget.Name), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[83] || (_cache[83] = _createTextVNode("New matrix: ", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.draft.newMatrixName) = $event)),
                                "aria-label": "New matrix name",
                                class: "ft-inline"
                              }, null, 512), [
                                [_vModelText, _ctx.draft.newMatrixName]
                              ])
                            ], 64))
                      ]),
                      (_ctx.draft.addSkills.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[84] || (_cache[84] = _createElementVNode("label", { class: "ft-label" }, "New skills", -1)),
                            _createElementVNode("div", _hoisted_186, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.addSkills, (s, i) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: s,
                                  class: "ft-chip"
                                }, [
                                  _createTextVNode(_toDisplayString(s), 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "ft-x",
                                    onClick: ($event: any) => (_ctx.draft.addSkills.splice(i, 1))
                                  }, "×", 8, _hoisted_187)
                                ]))
                              }), 128))
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.draft.addPeople.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[85] || (_cache[85] = _createElementVNode("label", { class: "ft-label" }, "New people", -1)),
                            _createElementVNode("div", _hoisted_188, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.addPeople, (p, i) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: p,
                                  class: "ft-chip"
                                }, [
                                  _createTextVNode(_toDisplayString(p), 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "ft-x",
                                    onClick: ($event: any) => (_ctx.draft.addPeople.splice(i, 1))
                                  }, "×", 8, _hoisted_189)
                                ]))
                              }), 128))
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.draft.ratings.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _cache[86] || (_cache[86] = _createElementVNode("label", { class: "ft-label" }, "Ratings", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.ratings, (r, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: _normalizeClass(["ft-item ft-item-tight", { 'ft-off': !r.keep }])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((r.keep) = $event)
                                }, null, 8, _hoisted_190), [
                                  [_vModelCheckbox, r.keep]
                                ]),
                                _createElementVNode("div", _hoisted_191, [
                                  _createElementVNode("span", _hoisted_192, _toDisplayString(r.person), 1),
                                  _createElementVNode("span", null, _toDisplayString(r.skill), 1),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": ($event: any) => ((r.level) = $event)
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LEVELS, (l, n) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: n,
                                        value: n
                                      }, _toDisplayString(n) + " · " + _toDisplayString(l), 9, _hoisted_194))
                                    }), 128))
                                  ], 8, _hoisted_193), [
                                    [
                                      _vModelSelect,
                                      r.level,
                                      void 0,
                                      { number: true }
                                    ]
                                  ])
                                ])
                              ], 2))
                            }), 128))
                          ], 64))
                        : _createCommentVNode("", true),
                      (!_ctx.draft.addSkills.length && !_ctx.draft.addPeople.length && !_ctx.draft.ratings.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_195, "Nothing to change — say what to add or rate below."))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'announcement')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.draft.text) = $event)),
                        rows: "4",
                        maxlength: "1000",
                        class: "ft-fit",
                        "aria-label": "Announcement"
                      }, null, 512), [
                        [_vModelText, _ctx.draft.text]
                      ]),
                      _createElementVNode("div", _hoisted_197, _toDisplayString(_ctx.draft.text.length) + " characters · your name is added at the end", 1),
                      _cache[87] || (_cache[87] = _createElementVNode("label", { class: "ft-label" }, "Send to", -1)),
                      _createElementVNode("div", _hoisted_198, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (l) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: l,
                            class: "ft-check ft-loc"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: l,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.draft.locations) = $event))
                            }, null, 8, _hoisted_199), [
                              [_vModelCheckbox, _ctx.draft.locations]
                            ]),
                            _createTextVNode(" " + _toDisplayString(l), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kind == 'event')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                      _createElementVNode("div", _hoisted_201, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.draft.name) = $event)),
                          maxlength: "200",
                          "aria-label": "Event name",
                          class: "ft-strong"
                        }, null, 512), [
                          [_vModelText, _ctx.draft.name]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.draft.date) = $event)),
                          "aria-label": "Date"
                        }, null, 512), [
                          [_vModelText, _ctx.draft.date]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "time",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.draft.startTime) = $event)),
                          "aria-label": "Start time"
                        }, null, 512), [
                          [_vModelText, _ctx.draft.startTime]
                        ]),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.draft.durationMinutes) = $event)),
                          "aria-label": "Length"
                        }, [
                          _cache[88] || (_cache[88] = _createElementVNode("option", { value: null }, "Length —", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DURATIONS, (d) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: d,
                              value: d
                            }, _toDisplayString(_ctx.durationLabel(d)), 9, _hoisted_202))
                          }), 128))
                        ], 512), [
                          [
                            _vModelSelect,
                            _ctx.draft.durationMinutes,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.draft.location) = $event)),
                          "aria-label": "Where"
                        }, [
                          _cache[89] || (_cache[89] = _createElementVNode("option", { value: null }, "Everyone", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (l) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: l,
                              value: l
                            }, _toDisplayString(l), 9, _hoisted_203))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.draft.location]
                        ])
                      ]),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.draft.description) = $event)),
                        rows: "2",
                        placeholder: "What to expect",
                        class: "ft-fit"
                      }, null, 512), [
                        [_vModelText, _ctx.draft.description]
                      ]),
                      _createElementVNode("label", _hoisted_204, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.draft.sendOut) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.draft.sendOut]
                        ]),
                        _cache[90] || (_cache[90] = _createTextVNode(" Also send it out as an announcement", -1))
                      ]),
                      (_ctx.draft.sendOut)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.draft.announcementText) = $event)),
                              rows: "3",
                              maxlength: "1000",
                              class: "ft-fit",
                              "aria-label": "Announcement text"
                            }, null, 512), [
                              [_vModelText, _ctx.draft.announcementText]
                            ]),
                            _createElementVNode("div", _hoisted_205, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (l) => {
                                return (_openBlock(), _createElementBlock("label", {
                                  key: l,
                                  class: "ft-check ft-loc"
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    value: l,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.draft.sendLocations) = $event))
                                  }, null, 8, _hoisted_206), [
                                    [_vModelCheckbox, _ctx.draft.sendLocations]
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(l), 1)
                                ]))
                              }), 128))
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.texting)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_207, "Posting texts everyone at " + _toDisplayString(_ctx.sendLocations.join(' and ')) + " right away. It can't be unsent.", 1))
                  : _createCommentVNode("", true),
                (_ctx.applyError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_208, _toDisplayString(_ctx.applyError), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_209, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.feedback) = $event)),
                    rows: "2",
                    placeholder: 'Want anything changed? e.g. ' + (_ctx.kind == 'improve' ? 'the shipping target is 98% on time, keep Hiring\'s name as it is…' : _ctx.kind == 'milestones' ? 'fewer steps, interviews done by mid-November…' : _ctx.kind == 'prepl10' ? 'split the to-dos into separate Issues, make the shipping one high priority…' : _ctx.kind == 'meetingcheckup' ? 'focus on how long the meeting runs…' : 'add a metric for safety incidents, make the goals weekly not monthly…'),
                    class: "ft-fit"
                  }, null, 8, _hoisted_210), [
                    [_vModelText, _ctx.feedback]
                  ]),
                  _createElementVNode("div", _hoisted_211, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ai-btn ai-btn-ghost",
                      disabled: !_ctx.feedback.trim() || _ctx.busy,
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.draftIt(true)))
                    }, "Revise", 8, _hoisted_212),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ai-btn ai-btn-ghost",
                      disabled: _ctx.busy,
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.startOver()))
                    }, "Start over", 8, _hoisted_213),
                    _createElementVNode("div", {
                      class: _normalizeClass(["ai-btn", { 'disable-button': !_ctx.canApply || _ctx.busy }]),
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.apply()))
                    }, _toDisplayString(_ctx.busy ? 'Saving…' : _ctx.confirmTexts ? 'Yes, ' + _ctx.applyLabel.toLowerCase() : _ctx.applyLabel), 3)
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.phase == 'done')
            ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                _createElementVNode("div", _hoisted_215, _toDisplayString(_ctx.doneText), 1),
                (_ctx.doneProblems.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_216, _toDisplayString(_ctx.doneProblems.join(' ')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_217, [
                  (_ctx.modal)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "ai-btn",
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.$emit('close')))
                      }, "Close"))
                    : (_ctx.doneLink)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: _ctx.doneLink,
                          class: "ai-btn"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.doneLinkLabel), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ai-btn ai-btn-ghost",
                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.startOver()))
                  }, "Make another")
                ])
              ]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_1)
      ], 6))
    : _createCommentVNode("", true)
}